import { Box, CircularProgress } from "@mui/material";

import { useAppSelector } from "app/redux-store-interactions";
import { Picker, selectPicker } from "features/render";
import { selectIsProcoreDesign } from "slices/explorer";

import { HOVER_CURSOR_PROGRESS_COLOR, HOVER_CURSOR_PROGRESS_ID } from "./utils";

// This doesn't update on the fly with camera movement (at least yet), so it doesn't need to use HTML interaction
// capabilities, but it just makes sense to keep it here.
export function MeasureHtmlInteractions() {
    const isProcoreDesign = useAppSelector(selectIsProcoreDesign);
    const picker = useAppSelector(selectPicker);

    if (isProcoreDesign) {
        return null;
    }

    if (picker === Picker.PointLine) {
        return <Loader />;
    }

    return null;
}

function Loader() {
    return (
        <Box
            id={HOVER_CURSOR_PROGRESS_ID}
            sx={{
                position: "absolute",
                pointerEvents: "none",
                translate: "4px -22px",
                color: HOVER_CURSOR_PROGRESS_COLOR,
                display: "none",
            }}
        >
            <CircularProgress size={14} thickness={6} color="inherit" />
        </Box>
    );
}
